
<template>
    <div class="center">
      <vs-dialog prevent-close v-model="active" @close="active = false">
        <template #header>
          <h4 class="not-margin">
            Editar registro
          </h4>
        </template>


        <div class="con-form">
            <vs-row>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="institucion" class="labelInput">
                            Institución
                        </label>
                        <vs-select filter class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" v-if="instituciones.length" :disabled="!instituciones.length" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('institucion')">
                                Requerido
                            </template>
                            <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="programa" class="labelInput">
                            Programa
                        </label>
                        <vs-select filter class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="nivel != ''" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('programa')">
                                Requerido
                            </template>
                            <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                        <div v-if="programa !== ''" @click="programa = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label for="nivel" class="labelInput">
                            Nivel Académico
                        </label>
                        <vs-select filter class="aqui pt-0" id="nivel" placeholder="Seleccionar Nivel Académico" :key="nivelId" v-model="nivel" :disabled="programa != ''" autocomplete="off">
                            <template #message-danger v-if="errorFields.includes('nivel')">
                                Requerido
                            </template>
                            <vs-option v-for="option in niveles" :key="option.id"  :label="option.text" :value="option.id">
                                {{option.text}}
                            </vs-option>
                        </vs-select>
                        <div v-if="nivel !== ''" @click="nivel = ''" class="tache">
                            <i class="far fa-times-circle"></i>
                        </div>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">Categoría</label>
                        <vs-select filter class="pt-0" placeholder="Categoría" v-model="categoria">
                            <vs-option v-for="(option, i) in categorias" :key="i" :label="option.nombre" :value="option.id">
                                <template #message-danger v-if="errorFields.includes('categoria')">
                                    Requerido
                                </template>
                                {{option.nombre}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4" v-if="categoria == 4">
                    <form autocomplete="off">
                        <label class="labelInput">Convenio</label>
                        <vs-select filter :loading="loadingConvenio" :disabled="!institucion" class="pt-0" placeholder="Convenio" v-model="convenio" :key="convenioId">
                            <template #message-danger v-if="errorFields.includes('convenio')">
                                Requerido
                            </template>
                            <vs-option v-for="(option, i) in convenios" :key="i" :label="option.nombre" :value="option.convenio_id">
                                {{option.nombre}}
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">Nombre</label>
                        <vs-input  type="text" class="pt-0"
                            v-model="nombre"
                            placeholder="Nombre" :disabled="disableOptions">
                            <template #message-danger v-if="errorFields.includes('nombre')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">Abreviatura</label>
                        <vs-input  type="text" class="pt-0"
                            v-model="abreviatura"
                            placeholder="Abreviatura" :disabled="disableOptions">
                            <template #message-danger v-if="errorFields.includes('abreviatura')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">Alcance</label>
                        <vs-select filter class="pt-0" placeholder="Alcance" v-model="alcance" :disabled="disableOptions">
                            <template #message-danger v-if="errorFields.includes('alcance')">
                                Requerido
                            </template>
                            <vs-option label="Inscripción" value="inscripcion">
                                Inscripción
                            </vs-option>
                            <vs-option label="Colegiaturas" value="colegiatura">
                                Colegiaturas
                            </vs-option>
                        </vs-select>
                    </form>
                </vs-col>
                <vs-col sm="12" lg="4">
                    <form autocomplete="off">
                        <label class="labelInput">Porcentaje</label>
                        <vs-input  type="number" min="0" class="pt-0"
                            v-model="porcentaje"
                            placeholder="Porcentaje" :disabled="disableOptions" >
                            <template #message-danger v-if="errorFields.includes('porcentaje')">
                                Requerido
                            </template>
                        </vs-input>
                    </form>
                </vs-col>
                <vs-col>
                    <form autocomplete="off">
                        <md-field>
                            <label>Descripción</label>
                            <md-textarea v-model="descripcion" :disabled="disableOptions"></md-textarea>
                        </md-field>
                    </form>
                </vs-col>
            </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false">
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        class="ml-auto"
                        @click="portEditarBecas()">
                        Guardar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico'
export default {
    props:[
      'value',
      'info',
      'institucionSelect',
      'instituciones',
      'institucionId',
      'cicloEscolar',
      'selectInfo'
    ],
    data:() => ({
        active: false,
        institucion: '',
        programa: '',
        programas: [],
        programaId: (new Date()).getTime(),
        loadingPrograma: false,
        nivel: '',
        niveles: [],
        nivelId: (new Date()).getTime(),
        loadingNivel: false,
        convenio: '',
        convenios: [],
        convenioId: (new Date()).getTime(),
        loadingConvenio: false,
        fecha: '',
        nombre: '',
        errorFields: [],
        categoria: '',
        categorias: [
            {
                'id': 1, 
                'nombre':'SEP',
                'descripcion': '',
                'clave': 'SEP'
            },
            {
                'id': 2, 
                'nombre':'UNAM',
                'descripcion': '',
                'clave': 'UNAM'
            },
            {
                'id': 3, 
                'nombre':'Fideicomiso',
                'descripcion': '',
                'clave': 'FIDEI'
            },
            {
                'id': 4, 
                'nombre':'Convenio',
                'descripcion': '',
                'clave': 'CONV'
            },
            {
                'id': 5, 
                'nombre':'Excelencia académica',
                'descripcion': '',
                'clave': 'EXAC'
            },
            {
                'id': 6, 
                'nombre':'Deportiva',
                'descripcion': '',
                'clave': 'DEP'
            },
            {
                'id': 7, 
                'nombre':'Apoyo socioeconómico',
                'descripcion': '',
                'clave': 'APSOC'
            },
            {
                'id': 8, 
                'nombre':'Apoyo para empleados',
                'descripcion': '',
                'clave': 'APEMP'
            },
            {
                'id': 10, 
                'nombre':'Promoción',
                'descripcion': '',
                'clave': 'PROM'
            },
        ],
        abreviatura: '',
        alcance: '',
        porcentaje: '',
        descripcion: '',
        disableOptions: false,
        convenioSelect: {}
    }),
    methods: {
        getInfo(){
            this.institucion = this.selectInfo.institucion_id
            if(this.selectInfo.programa_id > 0 && this.selectInfo.programa_id != null){
                this.programa = this.selectInfo.programa_id
                this.nivel = ''
            }else{
                this.nivel = this.selectInfo.nivel_academico_id
                this.programa = ''
            }
            this.categoria = this.selectInfo.categoria_beca_id
            this.categoria = this.selectInfo.categoria_beca_id
            this.convenio = this.selectInfo.convenio_id ? this.selectInfo.convenio_id : ''
            if(this.categoria == 4){
                this.nombre = ''
                this.abreviatura = ''
                this.alcance = ''
                this.porcentaje = ''
                this.descripcion = ''
                this.disableOptions = true
                if(this.convenios.length){
                    this.getInfoConvenio()
                }
            }else{
                this.nombre = this.selectInfo.nombre
                this.abreviatura = this.selectInfo.clave
                if(this.selectInfo.alcance){
                        this.alcance = this.selectInfo.alcance == 'inscripcion' ? 'inscripcion' : 'colegiatura'
                }else{
                    this.alcance = ''
                }
                this.porcentaje = this.selectInfo.porcentaje
                this.descripcion = this.selectInfo.descripcion
                this.disableOptions = false
            }
        },
        async getPrograma() {
            if(this.institucion){
                this.loadingPrograma = true
                const { data: response } = await academico.getPrograma(this.institucion)
                this.programas = response
                this.programaId = (new Date()).getTime()
                this.loadingPrograma = false
            }
        },
        async getNivelAcademico() {
            if(this.institucion){
                this.loadingNivel = true
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await academico.getNivelAcademico(params)
                this.niveles = response
                this.nivelId = (new Date()).getTime()
                this.loadingNivel = false
            }
        },
        async getConvenios() {
            if(this.categoria == 4 && this.institucion){
                this.loadingConvenio = true
                const params = {
                    "institucion_id": this.institucion
                }
                const { data: response } = await academico.getConvenios(params)
                this.convenios = response
                this.convenioId = (new Date()).getTime()
                this.loadingConvenio = false
                if(response){
                    this.getInfoConvenio()
                }
            }else{
                this.convenio = ''
            }
        },
        getInfoConvenio(){
            if(this.categoria == '4'){
                this.convenioSelect = this.convenios.filter((con) => con.convenio_id == this.convenio).shift();
                if(this.convenio){
                    this.nombre = this.convenioSelect.nombre ? this.convenioSelect.nombre : ''
                    this.abreviatura = this.convenioSelect.nombre ? this.convenioSelect.nombre : ''
                    this.alcance =  this.convenioSelect.alcance == 'inscripcion' ?'inscripcion' : 'colegiatura'
                    this.porcentaje = this.convenioSelect.porcentaje
                    this.descripcion = this.convenioSelect.descripcion
                    this.disableOptions = true
                }else{
                    this.convenio = ''
                    this.nombre = ''
                    this.abreviatura = ''
                    this.alcance =  ''
                    this.porcentaje = ''
                    this.descripcion = ''
                    this.disableOptions = true
                }
                this.disableOptions = true
            }else{
                this.nombre = this.selectInfo.nombre ? this.selectInfo.nombre : ''
                this.abreviatura = this.selectInfo.clave ? this.selectInfo.clave : ''
                if(this.selectInfo.alcanceTitle){
                    this.alcance = this.selectInfo.alcanceTitle == 'inscripcion' ?'inscripcion' : 'colegiatura'
                }else{
                    this.alcance = ''
                }
                this.porcentaje = this.selectInfo.porcentaje ? this.selectInfo.porcentaje : ''
                this.descripcion = this.selectInfo.descripcion ? this.selectInfo.descripcion : ''
                this.disableOptions = false
            }
        },
        sanityForm () {
            this.errorFields = []
            if (!this.institucion) {
                this.errorFields.push('institucion')
            }
            if(this.nivel == ''){
                if (!this.programa) {
                    this.errorFields.push('programa')
                }
            }
            if(this.programa == ''){
                if (!this.nivel) {
                    this.errorFields.push('nivel')
                }
            }
            if (!this.categoria) {
                this.errorFields.push('categoria')
            }
            if(this.categoria == 4){
                if(!this.convenio){
                    this.errorFields.push('convenio')
                }
            }
            if (!this.nombre) {
                this.errorFields.push('nombre')
            }
            if (!this.abreviatura) {
                this.errorFields.push('abreviatura')
            }
            if (!this.alcance) {
                this.errorFields.push('alcance')
            }
            if (!this.porcentaje) {
                this.errorFields.push('porcentaje')
            }
            if (!this.errorFields.length){
                return true
            } else {
                return null
            }
        },
        async portEditarBecas(){
            if(this.sanityForm()){
                const loading = this.$vs.loading()
                try{
                    const formData = new FormData()
                    formData.append("institucion_id", this.institucion)
                    formData.append("categoria_beca_id", this.categoria)
                    if(this.programa != ''){
                        formData.append("programa_id", this.programa)
                    }
                    if(this.nivel != ''){
                        formData.append("nivel_academico_id", this.nivel)
                        formData.append("programa_id", '0')
                    }
                    if(this.convenio){
                        formData.append("convenio_id", this.convenio)
                        formData.append("nombre", this.convenioSelect.nombre)
                        formData.append("alcance", this.convenioSelect.alcance)
                        formData.append("porcentaje", this.convenioSelect.porcentaje)
                        formData.append("descripcion", this.convenioSelect.descripcion)
                        formData.append("clave", this.convenioSelect.nombre)
                    }else{
                        formData.append("nombre", this.nombre)
                        formData.append("alcance", this.alcance)
                        formData.append("porcentaje", this.porcentaje)
                        formData.append("descripcion", this.descripcion)
                        formData.append("clave", this.abreviatura)
                    }
                    const { data: response } = await academico.portEditarBecas(formData, this.selectInfo.id)
                    loading.close()
                    this.active = false
                    this.$emit('refreshTable', this.institucion)
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa.',
                        text: 'Se a creado con éxito el registro.'
                    })
                }catch{
                    loading.close()
                    this.active = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        title: 'Algo salió mal.',
                        text: 'Póngase en contacto con el administrador.'
                    })
                }
            }
        },
    },
    watch:{
      value (val) {
          this.active = val
          if(this.active){
            this.getInfo()
          }
      },
      async active (val) {
          if (!val){
              this.$emit('input', val);
          }
      },
      institucion(){
            this.getPrograma()
            this.getNivelAcademico()
            this.getConvenios()
      },
    //   selectInfo(){
    //       this.getInfo()
    //   },
      categoria(){
            this.getConvenios()
        if(this.convenios.length){
            this.getInfoConvenio()
        }
      },
      convenio(){
        if(this.convenios.length){
            this.getInfoConvenio()
        }
      }
    }
}
</script>

<style lang="scss" scoped>
    .tache{
        position: absolute;
        cursor: pointer;
        top: 35px;
        @media only screen and (max-width: 768px) {
            left: calc(95% - 4em);
        }
        @media only screen and (min-width: 768px) {
            left: calc(98% - 4em);
        }

    }
</style>